import { render, staticRenderFns } from "./SectionOfQuestions.vue?vue&type=template&id=3295c90a&"
import script from "./SectionOfQuestions.vue?vue&type=script&lang=js&"
export * from "./SectionOfQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports